import { createMuiTheme } from '@material-ui/core/styles';

export const colortheme = createMuiTheme({
  palette: {
    primary: {
      light: '#ced6d5',
      main: '#0d362f',
      dark: '#254A43',
      contrastText: '#fffff2',
    },
    secondary: {
      light: '#ff7961',
      main: '#fff',
      dark: '#0d362f',
      contrastText: '#0d362f',
    },
  },
});

// window._sharedData.config.viewerId
// 4567123552
